import Icon from '../components/Icon.vue'

Icon.register({"print":{"width":512,"height":512,"paths":[{"d":"M464 192H448V81.9A24-24 0 0 1 441 65L383 7A24-24 0 0 1 366.1 0H88C74.7 0 64 10.7 64 24V192H48C21.5 192 0 213.5 0 240V372C0 378.6 5.4 384 12 384H64V488C64 501.3 74.7 512 88 512H424C437.3 512 448 501.3 448 488V384H500C506.6 384 512 378.6 512 372V240C512 213.5 490.5 192 464 192zM384 448H128V352H384V448zM128 224V64H320V104C320 117.2 330.8 128 344 128H384V224H128zM432 296C418.7 296 408 285.3 408 272S418.7 248 432 248 456 258.7 456 272 445.3 296 432 296z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/print.js
// module id = jhoS
// module chunks = 0